import { render, staticRenderFns } from "./DingdingWord.vue?vue&type=template&id=7ec0abb7&scoped=true&"
import script from "./DingdingWord.vue?vue&type=script&lang=js&"
export * from "./DingdingWord.vue?vue&type=script&lang=js&"
import style0 from "./DingdingWord.vue?vue&type=style&index=0&id=7ec0abb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec0abb7",
  null
  
)

export default component.exports